import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

// Define the base endpoint for crop calendar
const CROP_CALENDAR_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.CROP_CALENDAR,
  false // No tenant ID in the base URL
);

export const cropCalendarApi = {
  createCropCalendarForm: () => apiClient.get(`${CROP_CALENDAR_BASE}/form`),

  editCropCalendarForm: Id =>
    apiClient.get(`${CROP_CALENDAR_BASE}/form?is_edit=true&rule_id=${Id}`),

  submitCropCalendar: combinedData =>
    apiClient.post(`${CROP_CALENDAR_BASE}/rule`, combinedData),

  updateCropCalendar: (rule_id, combinedData) =>
    apiClient.put(`${CROP_CALENDAR_BASE}/rule?rule_id=${rule_id}`, combinedData)
};

export const getCropReport = ({ cursor, limit, cropIds, search_text }) =>
  apiClient.post(`${CROP_CALENDAR_BASE}/report`, {
    crop_ids: cropIds,
    cursor: cursor,
    limit: limit,
    search_text: search_text
  });
